import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Outlet, useNavigate, Link } from "react-router-dom";
import { Overlay, Popover, Button } from "react-bootstrap";

import { Collapse, Divider } from "antd";
import { CaretDownOutlined } from "@ant-design/icons"; // Ant Design iconi
import DoctorPopoverItems from "../Components/Dropdowns/DoctorPopoverItems";
import AppointmentPopoverItems from "./Dropdowns/AppointmentPopoverItems";
import PatientsPopoverItems from "./Dropdowns/PatientsPopoverItems";
import ReportsPopoverItems from "./Dropdowns/ReportsPopoverItems";
import ModulesPopoverItems from "./Dropdowns/ModulesPopoverItems";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { GoGear } from "react-icons/go";
import { HiOutlineLogout } from "react-icons/hi";
import NotificationPopover from "./Utility/NotificationPopover";
import ProfilePopover from "./Utility/ProfilePopover";
import { useLazyGetLabReportsQuery } from "../State/Api/AddLabReportsApiSlice";
import { useLazyGetallclinicinfoQuery } from "../State/Api/AddClinicInfoApiSlice";
import WardPopoverItems from "./Dropdowns/WardPopoverItems";

function ClinicSidebar() {
  const [triggerGetReports, { data, isLoading, error }] =
    useLazyGetLabReportsQuery();

  const handleAddReport = async () => {
    const userclinicid = localStorage.getItem("userClinicID");
    if (!userclinicid) return;

    const result = await triggerGetReports(userclinicid);

    if (result?.data) {
      navigate("/AddPatientReports", {
        state: {
          reportData: result.data,
        },
      });
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            src="/Images/Doctors.svg"
            alt="Doctors"
            style={{ height: ".8rem" }}
          />
          <span>Doctors</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ps-3">
          <li className="mb-1">
            <a
              onClick={() => {
                navigate("/DoctorsAdd", { state: {} });
              }}
              className="doctor-link"
            >
              Add Doctor
            </a>
          </li>
          <li>
            <a onClick={() => navigate("/Doctors")} className="doctor-link">
              View Doctor
            </a>
          </li>
        </ul>
      ),
    },
  ];

  const items1 = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".6rem" }}
            src="/Images/Appointment.svg"
            alt="Appointment"
          />
          <span>Appointments</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ps-3">
          <li className="mb-1">
            <a
              onClick={() => navigate("/AddAppointment")}
              className="doctor-link"
            >
              Add Appointment
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/clinic/appointments")}
              className="doctor-link"
            >
              Schedules
            </a>
          </li>
        </ul>
      ),
    },
  ];

  const items2 = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".8rem" }}
            src="/Images/Patients.svg"
            alt="Patient"
          />
          <span>Patients</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ps-3">
          <li className="mb-1">
            <a
              onClick={() =>
                navigate("/PatientsAdd", { state: { showModal: true } })
              }
              className="doctor-link"
            >
              Add Patient
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/ClinicPatients")}
              className="doctor-link"
            >
              View Patient
            </a>
          </li>
        </ul>
      ),
    },
  ];

  const items3 = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".8rem" }}
            src="/Images/Patients Reports.svg"
            alt="Reports"
          />
          <span>Reports</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ps-3">
          <li className="mb-1">
            <a onClick={handleAddReport} className="doctor-link">
              Add Reports
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/PatientReports")}
              className="doctor-link"
            >
              View Reports
            </a>
          </li>
        </ul>
      ),
    },
  ];

   const items4 = [
    {
      key: "1",
      label: (
        <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
          <img
            style={{ height: ".8rem" }}
            src="/Images/Patients Reports.svg"
            alt="Reports"
          />
          <span>Ward Allotment</span>
        </div>
      ),
      children: (
        <ul className="mb-0 ps-3">
          <li className="mb-1">
            <a onClick={() => navigate("/BedAllotment")} className="doctor-link">
              Bed Allotement
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/PatientAdmission")}
              className="doctor-link"
            >
              Patient Admission
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/MonitorTracking")}
              className="doctor-link"
            >
              Monitor & Care Tracking 
            </a>
          </li>
          <li>
            <a
              onClick={() => navigate("/WardPharmacy")}
              className="doctor-link"
            >
              Ward Pharmacy
            </a>
          </li>
        </ul>
      ),
    },
  ];

  // const items4 = [
  //   {
  //     key: "1",
  //     label: (
  //       <div className="d-flex align-items-center" style={{ gap: "1.6rem" }}>
  //         <img
  //           style={{ height: ".8rem" }}
  //           src="../Images/OT Management.svg"
  //           alt="Modules"
  //         />
  //         <span>Modules</span>
  //       </div>
  //     ),
  //     children: (
  //       <ul className="mb-0 ps-3">
  //         <li className="mb-1">
  //           <a onClick={() => navigate("/OTBookings")} className="doctor-link">
  //             OT Management
  //           </a>
  //         </li>
  //       </ul>
  //     ),
  //   },
  // ];

  const navigate = useNavigate();
  const [sidenavopen, setSideNavOpen] = useState(true);
  const [pageTitle, setPageTitle] = useState("Doctor Dashboard");
  const uniqueUserId = localStorage.getItem("userUniqueID");
  const [fetchClinic, { data: clinicData, isFetching, isError }] =
    useLazyGetallclinicinfoQuery();

  useEffect(() => {
    if (uniqueUserId) {
      fetchClinic(uniqueUserId);
    }
  }, [uniqueUserId]);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, []);

  const name = "Harish Kumar"; // replace with dynamic value
  const getInitials = (name) => {
    const names = (name?.trim() || "").split(" ");
    const initials = names
      .filter(Boolean) // removes empty strings
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    return initials.slice(0, 2);
  };

  const [show, setShow] = useState(false);
  const target = useRef(null);

  const handleToggle = () => setShow(!show);

  const [showOpen, setShowOpen] = useState(false);
  const target1 = useRef(null);
  const handleNotificationTogle = () => setShowOpen(!showOpen);

  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullscreen = async () => {
    if (!document.fullscreenElement) {
      try {
        await document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      } catch (err) {
        console.error("Fullscreen request denied:", err);
      }
    } else {
      try {
        await document.exitFullscreen();
        setIsFullscreen(false);
      } catch (err) {
        console.error("Exit fullscreen failed:", err);
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const style = `

.hover-bg:hover {
  background-color: #f5f5f5;
}

    .accordion-button {
          padding: unset !important;
    height: 2rem !important;
    max-width: unset !important;
    display: flex;
    flex-direction: row;
    border: unset;
    }

    .accordion-item{
      border: unset !important;
    }

    .accordion-button::after {
    flex-shrink: 0;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: auto;
    margin-right: 1rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: cover;
    transition: var(--bs-accordion-btn-icon-transition);
}

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: unset;
}

/* ========== Accordion Header ========== */
.doctor-collapse .ant-collapse-header {
  padding: 12px 16px;
  margin-left: .5rem;
  transition: background-color 0.3s;
  font-weight: 400;
  font-size: .8rem !important;
  border-radius: 6px !important; /* ✅ Rounded corners */
  background-color: transparent;
  color: white !important; /* ✅ White text by default */
}

/* Hover effect (no color change, just background) */
.doctor-collapse .ant-collapse-header:hover {
  background-color: rgba(255, 255, 255, 0.1); /* Light hover effect */
  color: white !important;
  border-radius: 10px;
}

/* Chevron icon to the right */
.doctor-collapse .ant-collapse-expand-icon {
  order: 2;
  margin-inline-start: auto;
  color: white; /* ✅ Chevron icon color white */
}

/* ========== Inner Link Styles ========== */
.doctor-link {
  color: white !important; /* ✅ White link text */
  text-decoration: none;
  padding: 4px 8px;
  display: block;
  border-radius: 4px;
  font-size: .8rem !important;
  transition: background-color 0.3s;
  font-size: 14px;
}

/* Hover on links */
.doctor-link:hover {
  background-color: rgba(255, 255, 255, 0.15); /* soft highlight */
  color: white !important; /* keep text white */
}

/* Optional: Panel background transparent */
.doctor-collapse .ant-collapse-content {
  background-color: transparent !important;
}




  `;

  return (
    <>
      <style>{style}</style>
      <div style={{ height: "100%" }} className="row gx-0">
        <nav
          container
          className={sidenavopen ? "sidebar col-md-2" : "collapsed sidebar"}
        >
          <div className="sidebar-bg" />
          <button
            onClick={() => setSideNavOpen(!sidenavopen)}
            className="expand-btn"
          >
            <i
              class="fa-regular fa-square-caret-left"
              style={{ color: "#3cc245" }}
            ></i>
          </button>

          <div class="sidebar-links">
            {clinicData && (
              <div className="d-flex align-items-center gap-3 mb-3">
                {clinicData?.additionalDetails?.logoUpload ? (
  <img
    style={{
      height: "2.5rem",
      width: "2.5rem",
      marginLeft: "0.1rem",
      borderRadius: "50%",
    }}
    src={
  clinicData?.additionalDetails?.logoUpload
    ? `${clinicData.additionalDetails.logoUpload}?${Date.now()}`
    : ""
}
    alt="Clinic Logo"
  />
) : (
  <div
    style={{
      height: "2.5rem",
      width: "2.5rem",
      marginLeft: "0.1rem",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      color:'#000',
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: "1rem",
    }}
  >
    {getInitials(clinicData?.inviteUser?.clinic_Hospital_Name)}
  </div>
)}
                <h5
                  className=""
                  style={{ display: !sidenavopen ? "none" : "block" }}
                >
                  {clinicData?.inviteUser?.clinic_Hospital_Name}
                </h5>
              </div>
            )}

            <div class="TvZMhVkOCp"></div>
            <div>
              <ul className="flex flex-col">
                <li>
                  <Link
                    to="/ClinicDashboard"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 mt-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      src="/Images/Dashboard.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Dashboard</p>
                  </Link>
                </li>

                {!sidenavopen ? (
                  <li className="">
                    <AppointmentPopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={items1}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )}

                {!sidenavopen ? (
                  <li className="">
                    <DoctorPopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={items}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )}

                {!sidenavopen ? (
                  <li className="mb-2">
                    <PatientsPopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={items2}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )}

                <li className="">
                  <Link
                    to="/Departments"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Departments.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Department</p>
                  </Link>
                </li>

                <li className="">
                  <Link
                    to="/Clinicprescription"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Prescription.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Prescription</p>
                  </Link>
                </li>

                <li className="">
                  <Link
                    to="/PatientReports"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Patients Reports.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Reports</p>
                  </Link>
                </li>

                <li className="">
                  <Link
                    to="/Billing"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Billing.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Billing</p>
                  </Link>
                </li>

                <li className="">
                  <Link
                    to="/OpCaseSheet"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Prescription.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Out Patient</p>
                  </Link>
                </li>

                <li className="">
                  <Link
                    to="/OTBookings"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/OT Management.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Modules</p>
                  </Link>
                </li>
                {/* <li className="">
                  <Link
                    to="/clinic/analytics"
                    className="accordion-fhjhkkn d-flex align-items-center gap-3 p-2 rounded-2 overflow-hidden"
                  >
                    <img
                      className="h-50"
                      style={{ height: "1.5rem" }}
                      src="/Images/Analyticsicons-1.svg"
                      alt=""
                      srcset=""
                    />
                    <p className="div-atagcolor">Analytics</p>
                  </Link>
                </li> */}

                 {/* {!sidenavopen ? (
                  <li className="mb-2">
                    <WardPopoverItems />
                  </li>
                ) : (
                  <li className="">
                    <Collapse
                      items={items4}
                      expandIconPosition="end"
                      bordered={false}
                      className="doctor-collapse"
                      style={{
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "transparent",
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretDownOutlined
                          style={{
                            fontSize: "14px",
                            color: "white",
                            transform: isActive
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        />
                      )}
                    />
                  </li>
                )} */}
              </ul>
            </div>
          </div>

          {clinicData && (
            <div className="d-flex flex-col gap-3 mt-3">
              <div class="TvZMhVkOCp"></div>
              <h5 className="">
                <div className="d-flex align-items-center gap-3 ms-2">
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      backgroundColor: "#E4E6EB",
                      color: "#000",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {getInitials(clinicData?.contactDetails?.contactName)}
                  </div>
                  <div style={{ display: !sidenavopen ? "none" : "block" }}>
                    <div className="d-flex flex-column gap-1">
                      <div>{clinicData?.contactDetails?.contactName}</div>
                      <p style={{ fontSize: "12px" }}>Admin</p>
                    </div>
                  </div>
                </div>
              </h5>
            </div>
          )}
        </nav>

        <div
          style={{
            display: "flex",
            flexGrow: "1",
            padding: "unset",
            height: "100%",
          }}
          className="col-md-10"
        >
          <div className="col-12 g-0 div-colcon">
            <div className="div-TM1vTuWchY flex-jt-sb">
              <div class="sidebar-top">
                <a class="logo__wrapper">
                  <div style={{ width: "15rem", marginLeft: "2rem" }}>
                    <img
                      style={{}}
                      src="/Images/Logo.png"
                      alt="Logo"
                      class="logo-small"
                    />
                  </div>
                </a>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3 div-W1ShPmHBDd">
                {/* Fullscreen Button */}
                <button
                  onClick={toggleFullscreen}
                  className="btn d-flex align-items-center justify-content-center"
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                  style={{ padding: "0.5rem", fontSize: "1rem" }}
                >
                  <i
                    className={`fa-solid ${
                      isFullscreen ? "fa-compress" : "fa-expand"
                    }`}
                  ></i>
                </button>

                {/* Notifications */}

                <NotificationPopover />
                <ProfilePopover />

                {/* Profile Button */}
              </div>

              <header id="hamburger-hd">
                <input type="checkbox" id="menyAvPaa" />
                <label id="burger" for="menyAvPaa">
                  <div></div>
                  <div></div>
                  <div></div>
                </label>
                <nav id="meny">
                  <div
                    style={{ height: "100%", backgroundColor: "#213343" }}
                    class="d-flex flex-column"
                  >
                    <div class="div-mV3nDcsCXh">
                      <div className="d-flex align-items-center gap-3 mt-3">
                        <img
                          className=""
                          style={{ height: "2.5rem", marginLeft: "0.5rem" }}
                          src="/Images/user5.svg"
                          alt=""
                          srcset=""
                        />
                        <h5
                          className="text-white"
                          style={{ display: !sidenavopen ? "none" : "block" }}
                        >
                          Clinic
                        </h5>
                      </div>
                    </div>
                    <div class="div-XbccJyGpRY">
                      <div class="d-flex flex-column div-Yb0Usyx31B">
                        {/* <span class="spn-HX8Z7l2ITc fw-semibold text-white">Clinic</span> */}
                        <ul class="ul-WvVKfbP6Pb">
                          <li onClick={() => navigate("/ClinicDashboard")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <img
                                className="h-50"
                                src="/Images/Dashboard.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Dashboard</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/clinic/appointments")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem", width: "14px" }}
                                src="/Images/Appointment.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Appointments</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/Doctors")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Doctors.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Doctors</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/Departments")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Departments.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Department</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/ClinicPatients")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Patients.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Patients</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/Clinicprescription")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Help"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Prescription.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Prescription</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/PatientReports")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Settings"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Patients Reports.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Patient Reports</span>
                            </a>
                          </li>
                          
                          <li onClick={() => navigate("/Billing")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Help"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Billing.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Billing</span>
                            </a>
                          </li>
                          <li onClick={() => navigate("/OpCaseSheet")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Help"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Prescription.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Out Patient</span>
                            </a>
                          </li>
                          <span className="fw-semibold text-white mt-2 mb-2">
                            modules
                          </span>
                          <li onClick={() => navigate("/OTBookings")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Logout"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/OT Management.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">OT Management</span>
                            </a>
                          </li>
                          {/* <li onClick={() => navigate("/ClinicSupport")}>
                            <a
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <img
                                className="h-50"
                                style={{ height: "1.5rem" }}
                                src="/Images/Patients.svg"
                                alt=""
                                srcset=""
                              />
                              <span class="link hide">Support</span>
                            </a>
                          </li> */}
                        </ul>
                      </div>
                    </div>

                    <div className="d-flex align-items-center gap-3 mt-3">
                      <h5
                        className=""
                        style={{ display: !sidenavopen ? "none" : "block" }}
                      >
                        <div className="d-flex align-items-center gap-3 ms-2">
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              backgroundColor: "#E4E6EB",
                              color: "#000",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            {getInitials(name)}
                          </div>
                          <div className="d-flex flex-column gap-1">
                            <div className="text-white">{name}</div>
                            <p style={{ fontSize: "12px", color: "#fff" }}>
                              Admin
                            </p>
                          </div>
                        </div>
                      </h5>
                    </div>
                  </div>
                </nav>
              </header>
            </div>
            <div id="dash-con">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClinicSidebar;
